import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.594.196a1.001 1.001 0 0 0-1.041-.09l-18 9a1 1 0 0 0-.068 1.752L7 14.767V19a1.001 1.001 0 0 0 1.447.895l3.873-1.938 3.165 1.9a1.01 1.01 0 0 0 .934.05.996.996 0 0 0 .567-.744l3-18a.997.997 0 0 0-.392-.968zm-4.34 17.19l-5.843-3.505 8.005-9.461-2.161 12.967zM9 17.382v-1.415l1.287.772L9 17.381zm6.09-13.309l-7.416 8.765-4.598-2.758L15.09 4.072z"
});

var SvgSendMajorMonotone = function SvgSendMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgSendMajorMonotone as S };